import { FileDownload } from "@mui/icons-material";
import { Button } from "@mui/material";
import { downloadFile } from "../../Queries/CandidateQueries";
import { useAuthToken } from "../../State/Hooks/authHooks";

export const ExportButton = ({
  exportUrlOrCallback,
  label = "Export",
  title = "Export Data",
}: {
  exportUrlOrCallback: string | (() => void);
  label?: string;
  title?: string;
}) => {
  const token = useAuthToken();
  return (
    <Button
      title={title}
      size="small"
      variant="outlined"
      color="primary"
      startIcon={<FileDownload color="primary" />}
      onClick={async () => {
        if (exportUrlOrCallback && typeof exportUrlOrCallback === "string") {
          await downloadFile(token, exportUrlOrCallback);
        } else if (exportUrlOrCallback && typeof exportUrlOrCallback === "function") {
          exportUrlOrCallback();
        }
      }}
    >
      {label}
    </Button>
  );
};
